// extracted by mini-css-extract-plugin
export default {"page":"Ho-z","landingBackground":"Io-z","nonLandingBackground":"Jo-z"};